import * as React from "react";

import './acknowledgements.scss';

import {cs}             from "@Common/react/chain-services";


    export const Acknowledgements = ({children})=> cs(
    ({}) => (
        <div className="acknowledgement-9h9">
            <div className="container">
                <h3 xd-qa-type="label" xd-qa-name="Terms and Acknowledgement header">Terms and Acknowledgement</h3>
                {children}
            </div>
        </div>
    )
);
